import React from "react";
import { observer } from "mobx-react-lite";
import CertificationDashboard from "./CertificationDashboard";

const DGNB23Dashboard = () => {
  const reportID = "9014e41e-4de1-11f0-8d80-a3723ac81760";
  return <CertificationDashboard reportID={reportID} />;
};

export default observer(DGNB23Dashboard);
